// add visibility to video
;
(function () {

    $(document)
        .on('modalOpened', function() {
            var $video = $('.js-c-deeplinks-modal-content-video');
            if (!$video.length) return false;

            $video.css({
                opacity: 1,
                visibility: 'visible'
            })
        })

})();